import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type AppointmentTimeSlotDataFragment = (
  { __typename: 'AppointmentTimeSlot' }
  & Pick<SchemaTypes.AppointmentTimeSlot, 'slot' | 'bookingLimit'>
);

export const AppointmentTimeSlotDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentTimeSlotData on AppointmentTimeSlot {
  slot
  bookingLimit
}
    `;